import { ElMessage } from "element-plus"; // 假设使用 Element Plus UI 框架

export const useMessage = () => {
  const success = (message) => {
    ElMessage({
      message,
      type: "success",
      duration: 2000,
    });
  };

  const error = (message) => {
    ElMessage({
      message,
      type: "error",
      duration: 2000,
    });
  };

  const warning = (message) => {
    ElMessage({
      message,
      type: "warning",
      duration: 2000,
    });
  };

  const info = (message) => {
    ElMessage({
      message,
      type: "info",
      duration: 2000,
    });
  };

  return {
    success,
    error,
    warning,
    info,
  };
};
